import React, { createContext, useContext, useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import classnames from "classnames";
import {useAppContext} from "../../components/context/appContext"

import { Link } from "react-router-dom";
import Grid from '@mui/material/Grid2';
import { Container, Box } from "@mui/material";

function StandardPage({ t, title, description, showPrinterStatus, showPrinterRFIDStatus, children }) {
  let formContent = null;
  let mainContent = null;

  const appContext = useAppContext();

  React.Children.forEach(children, (child) => {
    if (React.isValidElement(child)) {
      if (child.type === StandardPageTopContent) {
        formContent = child;
      } else if (child.type === StandardPageMainContent) {
        mainContent = child;
      }
    }
  });

  return (
    <>
      <Container sx={{ pt: 4, marginBottom: "53px" }}>
        <Grid container>
          <Grid size={12}>
            <Link to="/" className="btn-flat waves-effect">
              <i className="material-icons left">keyboard_backspace</i>{" "}
              {t("userprofile.back_to_home")}
             </Link>
          </Grid>
        </Grid>
        <Grid container>
          <Grid size={{md:3, xs:12}}></Grid>
          <Grid size={{md:6, xs:12}}>
            <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" >
              <h4>{title}</h4>
              <h6>{description}</h6>
            </Box>
          </Grid>
          <Grid size={{md:2, xs:12}}>
          {showPrinterStatus && (
            <Box  display="flex" flexDirection="column" justifyContent="center" alignItems="center" >
              <i className={classnames("medium material-icons", {
                    "green-text": appContext?.printerStatus === "ready",
                    "red-text": appContext?.printerStatus !== "ready",
                })}>
                print
              </i>
              <p>{appContext?.printerName}</p>
            </Box>
          )} 
          </Grid>
          <Grid size={{md:1, xs:12}}>
            {showPrinterRFIDStatus && (
              <Box  display="flex" flexDirection="column" justifyContent="center" alignItems="center" >
                <i className={classnames("medium material-icons", {
                      "green-text": appContext?.printerStatusRFID === "ready",
                      "red-text": appContext?.printerStatusRFID !== "ready",
                  })}>
                  print
                </i>
                <p>{appContext?.printerNameRFID ?? "RFID Printer"}</p>
              </Box>
            )} 
          </Grid>
        </Grid>
        {formContent && formContent}
        {mainContent}
      </Container>
    </>
  );
}

export const PrinterTypes = {
  BROTHER:"brother",
  RFID:"rfid",
  DUAL:"dual"
}


export const StandardPageTopContent = ({ children }) => <>{children}</>;
export const StandardPageMainContent = ({ children }) => <>{children}</>;

StandardPage.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
});

export default compose(
  withTranslation(),
  connect(mapStateToProps)
)(StandardPage);
